module.exports = __webpack_public_path__ + "img/person_wb.9e3ca061.jpg";